import React from 'react';
import { useSelector} from 'react-redux'
import useGlobalConfig from '../../../hooks/globalConfig';
const Logo = () => {
  const {siteName, logoOficialUrl1x4} = useGlobalConfig()
  const activo = useSelector(store => store.usuario.activo)
  return (
    <div className= 
    {
      activo ? (
        'logo_content_dash'
      ) : (
        'logo_content'
      )
      }
    >
        <img src={`${logoOficialUrl1x4}`} alt={siteName} />
    </div>

  );
};

export default Logo;
